// extracted by mini-css-extract-plugin
var _1 = "vmbuG";
var _2 = "rmkwf";
var _3 = "DZcLD";
var _4 = "dy4PU";
var _5 = "gjqRi";
var _6 = "hMmbR";
var _7 = "dk2NL";
var _8 = "VqVru";
var _9 = "vn9Mk";
var _a = "pXwdB";
var _b = "_eE88";
var _c = "S11yW";
var _d = "Ekjub";
var _e = "t9hx3";
var _f = "LesyR";
export { _1 as "compact", _2 as "contentColumn", _3 as "contentGap1", _4 as "contentGap2", _5 as "contentGap3", _6 as "contentLine1", _7 as "contentLine2", _8 as "contentLine3", _9 as "full", _a as "mailListShimmerContainer", _b as "paddingFirstMessage", _c as "paddingMessage", _d as "personaColumn", _e as "personaGap", _f as "shimmerRow" }
